import { useStorage, type RemovableRef } from '@vueuse/core';

type ExitOfferState = {
  applied: boolean;
  wasUsed: RemovableRef<boolean>;
};

const MODAL_STORAGE_KEY = 'exit-offer-modal';

export const useExitOfferStore = defineStore('exit-offer', {
  state(): ExitOfferState {
    return {
      applied: false,
      wasUsed: useStorage(MODAL_STORAGE_KEY, false),
    };
  },

  actions: {
    activate() {
      this.applied = true;
      this.wasUsed = true;
    },

    disable() {
      this.applied = false;
      this.wasUsed = true;
    },
  },
});
